import { useContext, useState } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import { useTranslation } from "react-i18next";
import { Box, Button, FormControl, IconButton, MenuItem, Select, TextField, Typography } from "@mui/material";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { SendToDepartment, SendToUsername } from "../../../api/request/dashboard/dashboard";
import toast from "react-hot-toast";
import ReactQuill from "react-quill";

const NewMail = ({ open, onClose }) => {
    const { darkMode } = useContext(ThemeContext);
    const [content, setContent] = useState("");
    const [selectedDepartment, setSelectedDepartment] = useState("");
    const [selectedRecipientType, setSelectedRecipientType] = useState("");
    const [selectedUser, setSelectedUser] = useState("");
    const [subject, setSubject] = useState("");
    const { t } = useTranslation()
    const { users = [], departments = [] } = useSelector(state => state.email, shallowEqual);
    const navigate = useNavigate()

    const handleClose = () => {
        setSelectedDepartment("");
        setSelectedRecipientType('');
        setContent("");
        setSubject('');
        onClose()
    };

    const handleChange = (value) => {
        setContent(value);
        console.log("Content updated:", value);
    };

    const quillModules = { toolbar: false };

    const handleRecipientTypeChange = (event) => {
        setSelectedRecipientType(event.target.value);
    };

    const handleDepartmentChange = (event) => {
        setSelectedDepartment(event.target.value);
        console.log("Selected department:", event.target.value);
    };

    const selectedUserDetails = users.find(user => user.id === selectedUser);

    const handleSendMail = async () => {

        if (!subject || !content || (!selectedDepartment && !selectedUser)) {
            toast.error("Please fill in all fields.");
            return;
        }

        try {
            const data = {
                content: content,
                departmentId: selectedDepartment,
                subject: subject,
            };


            const dataForuser = {
                content: content,
                subject,
                toUserType: selectedUserDetails ? selectedUserDetails.senderType : null,
                toUsername: selectedUser,
            }
            const response = await (selectedRecipientType === "department"
                ? SendToDepartment(data)
                : SendToUsername(dataForuser));

            if (response.status === 200) {
                toast.success("Mail sent successfully!");
            } else {
                toast.error("Failed to send mail.");
            }

            handleClose();
        } catch (error) {
            console.error("Error sending mail:", error);
            // toast.error("Error sending mail.");
        }
    };

    return (
        <Box display="flex" flexDirection="column" height="100vh">
            <Box display="flex" alignItems="center" justifyContent="space-between" px={2} py={1}>
                <Box display="flex" alignItems="center">
                    <IconButton onClick={onClose}><ArrowBackIosNewIcon fontSize="small" onClick={() => navigate('/mails')} /></IconButton>
                    <Typography fontSize={18} fontWeight={600} ml={1}>{t('createNewMail')}</Typography>
                </Box>
            </Box>

            <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", px: 3, py: 3 }}>
                <Box>
                    <Box sx={{ backgroundColor: darkMode ? "#151924" : "#f5f5f5", height: "400px", display: 'flex', gap: 2, flexDirection: 'column' }}>
                        <Box sx={{ display: "grid", gridTemplateColumns: "1fr", gap: 2 }}>

                            <FormControl fullWidth>
                                <Typography>{t('to')}</Typography>
                                <Select label='' value={selectedRecipientType} onChange={handleRecipientTypeChange} fullWidth variant="outlined" sx={{ height: 45 }}>
                                    <MenuItem value="department">{t('department')}</MenuItem>
                                    <MenuItem value="client">{t('client')}</MenuItem>
                                </Select>
                            </FormControl>

                            {selectedRecipientType === "department" && (
                                <FormControl fullWidth>
                                    <Typography>{t('selectDepartment')}</Typography>
                                    <Select label="" value={selectedDepartment} onChange={handleDepartmentChange} fullWidth variant="outlined" sx={{ height: 45 }}>
                                        {departments.map((department, index) => (
                                            <MenuItem key={index} value={department.id}>{department.description}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                            {selectedRecipientType === "user" && (
                                <FormControl fullWidth>
                                    <Typography>{t('selectClient')}</Typography>
                                    <Select label="" value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} fullWidth variant="outlined" sx={{ height: 45 }}>
                                        {users.map((user, index) => (
                                            <MenuItem key={index} value={user.id}>{user.description}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            )}
                            <Typography>{t('subject')}</Typography>
                            <TextField placeholder={t('entersubject')} variant="outlined" fullWidth value={subject} onChange={(e) => setSubject(e.target.value)} sx={{ "& .MuiOutlinedInput-root": { height: 45 } }} />
                            <Typography>{t('composeMail')}</Typography>
                            <ReactQuill value={content} onChange={handleChange} theme="snow" placeholder={t('writeyourmessage')} modules={quillModules} style={{ height: "200px", marginBottom: "2px", color: darkMode ? "#fff" : "#000", border: `1px solid ${darkMode ? "var(--borderDark)" : 'var(--borderLight)'}` }} />
                        </Box>
                        <Box sx={{ display: "flex", justifyContent: "center", width: '100%' }}>
                            <Button fullWidth onClick={handleSendMail} variant="contained" color="primary">{t('send')}</Button>
                        </Box>
                    </Box>

                </Box>
            </Box>
        </Box>
    );
};

export default NewMail